<template>
  <div>

    <div class="row">

      <div :key="idx+1" :class=" getRowClass(idx)" class="reason-row-wrapper" v-for="(log,idx) in job.logs">
        <div class="col-12">
          <JobReasonRow class="row" :log="log" :job="job" :idx="idx" @deleteReason="deleteReason($event)"/>
          <hr>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <button class="btn btn-light  pull-right float-right" @click="addNewReason()"><i class="fas fa-plus"></i> {{ $t('jobs.detail.reasons.reason') }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import JobReasonRow from "@/components/jobs/JobReasonRow";

export default {
  name: "JobReasonLog",
  components: {JobReasonRow},
  props: [
    'job', 'reasonIndexWarning'
  ],
  data() {
    return {}
  },
  computed: {},
  methods: {
    getRowClass(index) {
      let hasError = _.includes(this.reasonIndexWarning, index)
      return hasError ? '  row-red' : ' '
    },
    async saveReasons() {

      let jobLog = {
        id: this.job.id,
        logs: this.job.logs
      }
      await this.$store.dispatch('jobs/patch', jobLog).catch(e => {
        this.$swal('error')
      })
      this.swalToastSuccess(this.$t('ui.saved'))
    },
    async deleteReason(idx) {
      // REMOVE FROM FIREBASE ASWELL
      let response = await this.$swal({
        title: 'Are you sure',
        icon: 'warning',
        showConfirmButton: true,
        showCancelButton: true
      })
      this.job.logs.splice(idx, 1)
      let jobLog = {
        id: this.job.id,
        logs: this.job.logs
      }
      await this.$store.dispatch('jobs/patch', jobLog).catch(e => {
        this.$swal('error')
      })
    },
    addNewReason() {
      this.job.logs.push({
        amount: 1,
        timeInMs: 0,
        reason: null
      })
    }
  },
  created() {
    if (this.job.logs === undefined) {
      this.$store.dispatch('jobs/patch', {
        id: this.job.id, logs: [{
          amount: 1,
          timeInMs: 0,
          reason: null
        }]
      }).catch(e => {
        this.$swal('error')
      })

    }

  }
}
</script>

<style scoped>
.row-red {
  border: 1px solid #d21616;
}

.reason-row-wrapper {
  margin-bottom: 20px;
}

.btn-light {
  color: #000;
  background-color: #e9ecef;
  border-color: #e4e4e4;
}
</style>